module.exports = __webpack_public_path__ + "static/media/pcclgt2.ed6455cb.png";